export const typography = {
  h1: {
    fontSize: "2.5rem",
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: "2rem",
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: "1.75rem",
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontSize: "1.50rem",
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: "1.25rem",
    fontWeight: 400,
    lineHeight: 1.4,
  },
  body1: {
    fontSize: "1rem",
    lineHeight: 1.5,
  },
  body2: {
    fontSize: "0.875rem",
    lineHeight: 1.4,
  },
  subtitle1: {
    fontSize: "1.25rem",
    fontStyle: "italic",
    lineHeight: 1.4,
  },
  subtitle2: {
    fontSize: "0.875rem",
    lineHeight: 1.57,
    fontWeight: 400,
  },
  caption: {
    fontSize: "0.75rem",
  },
  HD1: {
    fontSize: "0.75rem", // 12px
    lineHeight: "0.875rem",
    fontWeight: 600,
  },
  HD2: {
    fontSize: "0.875rem", // 14px
    lineHeight: "1.125rem",
    fontWeight: 600,
  },
  HD3: {
    fontSize: "1rem", // 16px
    lineHeight: "1.25rem",
    fontWeight: 600,
  },
  HD4: {
    fontSize: "1.125rem", // 18px
    lineHeight: "1.375rem",
    fontWeight: 600,
  },
  HD5: {
    fontSize: "1.375rem", // 22px
    lineHeight: "1.625rem",
    fontWeight: 600,
  },
  HD6: {
    fontSize: "1.75rem", // 28px
    lineHeight: "2.125rem", // 34px
    fontWeight: 400,
  },
  BD1: {
    fontSize: "0.6875rem", // 11px
    lineHeight: "0.8125rem", // 13px
    fontWeight: 400,
  },
  BD2: {
    fontSize: "0.75rem", // 12px
    lineHeight: "1rem", // 16px
    fontWeight: 400,
  },
  BD3: {
    fontSize: "0.875rem",
    lineHeight: "1.125rem",
    fontWeight: 400,
  },
  BD4: {
    fontSize: "1rem",
    lineHeight: "1.25rem",
    fontWeight: 400,
  },
  BD5: {
    fontSize: "1.125rem",
    lineHeight: "1.375rem",
    fontWeight: 400,
  },
  PD1: {
    fontSize: "0.6875rem",
    lineHeight: "1.125rem",
    fontWeight: 400,
  },
  PD2: {
    fontSize: "0.875rem",
    lineHeight: "1.375rem",
    fontWeight: 400,
  },
  HM1: {
    fontSize: "0.9375rem",
    lineHeight: "1.125rem",
    fontWeight: 600,
  },
  HM2: {
    fontSize: "1.0625rem", // 17px
    lineHeight: "1.25rem",
    fontWeight: 600,
  },
  HM3: {
    fontSize: "1.1875rem",
    lineHeight: "1.4375rem",
    fontWeight: 600,
  },
  HM4: {
    fontSize: "1.375rem", // 22px
    lineHeight: "1.625rem", // 26px
    fontWeight: 600,
  },
  HM5: {
    fontSize: "1.6875rem", // 27px
    lineHeight: "2rem", // 32px
    fontWeight: 600,
  },
  HM6: {
    fontSize: "2.125rem", // 34px
    lineHeight: "2.5625rem", // 41px
    fontWeight: 600,
  },
  BM1: {
    fontSize: "0.8125rem", // 13px
    lineHeight: "1rem", // 16px
    fontWeight: 400,
  },
  BM2: {
    fontSize: "0.9375rem", // 15px
    lineHeight: "1.125rem", // 18px
    fontWeight: 400,
  },
  BM3: {
    fontSize: "1.0875rem", // 17px
    lineHeight: "1.25rem", // 20px
    fontWeight: 400,
  },
  BM4: {
    fontSize: "1.1875rem", // 19px
    lineHeight: "1.4375rem", // 23px
    fontWeight: 400,
  },
  BM5: {
    fontSize: "1.375rem", // 22px
    lineHeight: "1.6875rem", // 27px
    fontWeight: 400,
  },
  PM1: {
    fontSize: "0.8125rem", // 13px
    lineHeight: "1.25rem", // 20px
    fontWeight: 400,
  },
  PM2: {
    fontSize: "1.0625rem", // 17px
    lineHeight: "1.625rem", // 26px
    fontWeight: 400,
  },
};

export const textColor = {
  main: "#212121",
  secondary: "#757575",
  disabled: "#BDBDBD",
  white: "#FFFFFF",
  error: "#D32F2F",
  warning: "#EF6C00",
  info: "#1565C0",
  success: "#388E3C",
  caution: "#85711C",
};

export type ITypography = keyof typeof typography;
